import { apolloClient } from '../apolloClient'
import { setGlobal } from '../../global/useGlobal'
import { GET_USER_KEYS_DELIVERY_EVENT_INVITATIONS } from './queries/GET_USER_KEYS_DELIVERY_EVENT_INVITATIONS'
import { EventTypes } from '../../screens/AppointmentsScreen/constants'
import { GetUserKeysDeliveryEventInvitations } from '../types/GetUserKeysDeliveryEventInvitations'

export const getUserKeysDeliveryEventInvitations = async () => {
  try {
    const response = await apolloClient.query<GetUserKeysDeliveryEventInvitations>({
      query: GET_USER_KEYS_DELIVERY_EVENT_INVITATIONS,
    })

    const listWithType = response.data.listUserKeysDeliveryEventInvitations.map(event => {
      const type = { type: EventTypes.KEYS_DELIVERY }
      return Object.assign(event, type)
    })

    if (response) {
      await setGlobal({
        userKeysDeliveryEventInvitations: listWithType,
        shouldRefreshKeysDelivery: false,
      })
    }
  } catch (e) {
    console.log('Error at get keys delivery event: ', e)
  }
}
